import script from "./ViewSpecialApprovalType.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSpecialApprovalType.vue?vue&type=script&setup=true&lang=js"

import "./ViewSpecialApprovalType.vue?vue&type=style&index=0&id=59f4dec2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f4dec2"]])

export default __exports__